export const policyStatus = {
  ruw: 'Referred to UW',
  auw: 'Approved by UW',
  duw: 'Declined by UW',
  air: 'Additional Information Required',
  pen: 'Pending'
};
